import {addPartnerPaymentCard} from "../Util/queries";
import {CARD_UPDATE_STATES, PARTNER_CREDIT_UPDATE_CARD_STATE} from "../Components/Payments/creditCardInfoSection";

export const AddPartnerCard = (email, stripe_token) => async (dispatch) => {
    try {
        let data = {
            "emailAddress": email,
            "stripeToken": stripe_token
        }
        let cardAddingReq = await addPartnerPaymentCard(data);
        if (cardAddingReq.status === 200 || cardAddingReq.status === 201 || cardAddingReq.status === 204) {
            dispatch({
                type: PARTNER_CREDIT_UPDATE_CARD_STATE,
                payload: CARD_UPDATE_STATES.success
            })
        } else throw new Error(cardAddingReq.statusText);
    } catch (e) {
        dispatch({
            type: PARTNER_CREDIT_UPDATE_CARD_STATE,
            payload: CARD_UPDATE_STATES.failed
        })
        console.error(e);

    }
}